<template>
  <div id="openlogin">
    <div v-show="!qrcodeLogin" class="login-pc" v-if="step1">
      <div class="tel-contain">
        <div class="error-msg1" v-show="isShowMsg">
          <span>{{errorMsg}}</span>
        </div>
        <input class="tel"
          v-model="tel1"
          maxlength="11"
          type="text"
          @change="telChangeAction"
          @focus="telFocusAction"
          name=""
          placeholder="输入手机号码"
          @keyup.enter="telAction"
          autofocus="true"/>
      </div>
      <div class="next-step" @click="telAction">继续</div>
    </div>
    <div v-show="!qrcodeLogin" class="login-pc" v-else>
      <div class="tel-contain1">
        <div class="error-msg" v-show="isShowMsg1">
          <span v-html="errorMsg1"></span>
        </div>
        <input class="tel"
          v-model="tel2"
          type="text"
          readonly/>
      </div>
      <div class="psw-contain">
        <input class="psw"
          type="password"
          v-model="psw1"
          @focus="telCaptchaFocusAction"
          placeholder="您已注册，请输入密码"
          @keyup.enter="loginAction"
          autofocus="true"/>
      </div>
      <div class="forget-psw">
        <a href="dcf/minisite.html#/forget?c=home_fax.png" target="_blank">
          忘记密码
        </a>
      </div>
      <div class="captcha-container" v-if="captchaContainer">
        <input @focus="telCaptchaFocusAction" placeholder="输入验证码"  v-model="captchaCode" class="captcha-code">
        <img :src="catpchaImg" class="captcha-img">
      </div>
      <div class="login-next-step" @click="loginAction">继续</div>
      <div class="return-back" @click="returnBackAction"></div>
    </div>
  </div>
</template>

<script>
import modalLogin from './ModalLogin'

export default {
  extends: modalLogin
}
</script>

<style lang="scss">
body{
  background-color: rgba(#fff, 0.2);
}
</style>
<style lang="scss" scoped>
@import "~@/assets/css//utils";
@import "../css/theme-config";

$bgcolor: #fff;
$fontcolor: #000;

#openlogin{
  width: 80%;
  margin: 0 auto;
}

.login-pc{
  height: 276px;
  position: relative;
  text-align: center;
  .return-back{
    position: absolute;
    height: 30px;
    width: 30px;
    left: 0;
    top: 0;
    cursor: pointer;
    &:before{
      @include icon();
      content: $ICO-BACK;
      color: #fff;
      top: -30px;
      left: 0px;
    }
  }
}

.tel-contain{
  height: 42px;
  width: 100%;
  margin-top: 58px;
  position: relative;
  .tel{
    height: 40px;
    width: 96%;
    padding: 0 8px;
    border: none;
  }
  .error-msg{
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    color: $fontcolor;
    border-radius: 20px;
    position: absolute;
    top: -38px;
    width: 100%;
    text-align: left;
    background-color: $bgcolor;
    span{
      margin-left: 10px;
    }
  }
  .error-msg1{
    // height: 28px;
    line-height: 16px;
    // padding: 5px 10px;
    padding-left: 4.5%;
    padding-right: 4.5%;
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 12px;
    color: $fontcolor;
    border-radius: 20px;
    position: absolute;
    top: -48px;
    width: 91%;
    text-align: left;
    background-color: $bgcolor;
    span{
      // padding: 5px 10px;
      // margin-left: 10px;
    }
  }
}
.captcha-container{
  height: 42px;
  margin-top: 8px;
  .captcha-code{
    display: inline-block;
    width: 50%;
    height: 36px;
    float: left;
    padding-left: 10px;
  }
  .captcha-img{
    display: inline-block;
    width: 40%;
    height: 40px;
    background-color: #0f0;
    float: right;
  }
}
.tel-contain1{
  height: 42px;
  width: 100%;
  margin-top: 38px;
  position: relative;
  .tel{
    height: 40px;
    width: 96%;
    padding: 0 8px;
    border: none;
  }
  .error-msg{
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    color: $fontcolor;
    border-radius: 20px;
    position: absolute;
    top: -35px;
    width: 100%;
    text-align: left;
    background-color: $bgcolor;
    span{
      margin-left: 10px;
    }
  }
}
.psw-contain{
  height: 42px;
  width: 100%;
  margin-top: 10px;
  .psw{
    height: 40px;
    width: 96%;
    padding: 0 8px;
    border: none;
  }
}
.forget-psw{
    height: 12px;
    line-height: 12px;
    text-align: right;
    font-size: 12px;
    margin-top: 10px;
    a{
      color: #fff;
    }
  }
.next-step{
  height: 38px;
  width: 40%;
  background-color: $bgcolor;
  margin-left: 30%;
  margin-top: 50px;
  margin-bottom: 30px;
  border-radius: 100px;
  line-height: 38px;
  color: $fontcolor;
  font-size: 16px;
  cursor: pointer;
}
.login-next-step{
  height: 38px;
  width: 40%;
  background-color: $bgcolor;
  margin-left: 30%;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 100px;
  line-height: 38px;
  color: $fontcolor;
  font-size: 16px;
  cursor: pointer;
}
.login_icon{
  width: 0.5rem;
  height: 0.5rem;
  position: absolute;
  right: 0.04rem;
  bottom: 0.04rem;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.25, 0.5, 0.5, 0.9) 0s;
  background-repeat: no-repeat;
  background-size: 1rem 1rem;
  background-image: url('/imgs/portal/login/login_icon.jpg');
  @include media2x(url('/imgs/portal/login/login_icon@2x.jpg'));
  background-position: 0rem -0.5rem;
  @include mediaQuery() {
    height: 1rem;
    width: 1rem;
    background-size: 2rem 2rem;
    background-position: 0 -1rem;
    -webkit-tap-highlight-color: transparent;
  }

  &.qrcode{
   background-position: -0.5rem 0rem;
   @include mediaQuery() {
    background-position: -1rem 0;
   }
  }
}
</style>



// WEBPACK FOOTER //
// OpenLogin.vue?202a602e